const PracticeActions = {
  DISPLAY_PRACTICE_LIST_SUCCESS: 'DISPLAY_PRACTICE_LIST_SUCCESS',
  SAVE_PRACTICE_SUCCESS: 'SAVE_PRACTICE_SUCCESS',
  UPDATE_PRACTICE_SUCCESS: 'UPDATE_PRACTICE_SUCCESS',
  GET_LOGGED_PRACTICE_INFO: 'GET_LOGGED_PRACTICE_INFO',
  SET_SELECTED_PRACTICE: 'SET_SELECTED_PRACTICE',
  UNSET_SELECTED_PRACTICE: 'UNSET_SELECTED_PRACTICE',
  ALTER_SELECTED_PRACTICE: 'ALTER_SELECTED_PRACTICE',
  ACTIVATE_PRACTICE_SUCCESS: 'ACTIVATE_PRACTICE_SUCCESS',
  SET_PRACTICE_PAYMENT_SUCCESS: 'SET_PRACTICE_PAYMENT_SUCCESS',
};

const AuthActions = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT: 'LOGOUT',
  SET_REDIRECT_PATH: 'SET_REDIRECT_PATH',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  PASSWORD_RESET_SUCCESS: 'PASSWORD_RESET_SUCCESS',
  FORGOT_PASSWORD_REQUEST: 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_RESET: 'FORGOT_PASSWORD_RESET',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  PASSWORD_POLICY: 'PASSWORD_POLICY',
  GET_PRIVACY_POLICY: 'GET_PRIVACY_POLICY',
};

const StaffActions = {
  GET_STAFF_MEMBERS_SUCCESS: 'GET_STAFF_MEMBERS_SUCCESS',
  ADD_STAFF_MEMBER_SUCCESS: 'ADD_STAFF_MEMBER_SUCCESS',
  TOGGLE_ADD_EDIT_STAFF_MEMBER: 'TOGGLE_ADD_EDIT_STAFF_MEMBER',
  TOGGLE_DELETE_STAFF_MEMBER: 'TOGGLE_DELETE_STAFF_MEMBER',
  SET_SELECTED_STAFF_MEMBER: 'SET_SELECTED_STAFF_MEMBER',
  UNSET_SELECTED_STAFF_MEMBER: 'UNSET_SELECTED_STAFF_MEMBER',
  UPDATE_STAFF_MEMBER_SUCCESS: 'UPDATE_STAFF_MEMBER_SUCCESS',
  DELETE_STAFF_MEMBER_SUCCESS: 'DELETE_STAFF_MEMBER_SUCCESS',
  SET_STAFF_MEMBER_TO_INACTIVE: 'SET_STAFF_MEMBER_TO_INACTIVE',
};

const TransactionActions = {
  GET_PRACTICE_TRANSACTIONS_STARTED: 'GET_PRACTICE_TRANSACTIONS_STARTED',
  GET_PRACTICE_TRANSACTIONS_PAGE_SUCCESS:
    'GET_PRACTICE_TRANSACTIONS_PAGE_SUCCESS',
  GET_PRACTICE_TRANSACTIONS_SUCCESS: 'GET_PRACTICE_TRANSACTIONS_SUCCESS',
  GET_TRANSACTION_DETAIL_SUCCESS: 'GET_TRANSACTION_DETAIL_SUCCESS',
  PROCESS_TRANSACTION_REFUND_SUCCESS: 'PROCESS_TRANSACTION_REFUND_SUCCESS',
  PROCESS_NEW_TRANSACTION_SUCCESS: 'PROCESS_NEW_TRANSACTION_SUCCESS',
  SEND_TRANSACTION_RECEIPT_SUCCESS: 'SEND_TRANSACTION_RECEIPT_SUCCESS',
  GET_DAILY_TRANSACTIONS: 'GET_DAILY_TRANSACTIONS',
  GET_SPREEDLY_TRANSACTION: 'GET_SPREEDLY_TRANSACTION',
  POST_SPREEDLY_PAYMENT_INFO: 'POST_SPREEDLY_PAYMENT_INFO',
  CANCEL_TRANSACTION: 'CANCEL_TRANSACTION',
  RESEND_SPREEDLY_LINK: 'RESEND_SPREEDLY_LINK',
  UPDATE_TRANSACTION: 'UPDATE_TRANSACTION',
};

const ReportingActions = {
  GET_PRACTICE_DAILY_REPORTS_SUCCESSS: 'GET_PRACTICE_DAILY_REPORTS_SUCCESSS',
  GET_PRACTICE_PAYOUT_REPORTS_SUCCESS: 'GET_PRACTICE_PAYOUT_REPORTS_SUCCESS',
  GET_TRANSACTION_REPORT_STARTED: 'GET_TRANSACTION_REPORT_STARTED',
  GET_TRANSACTION_REPORT_SUCCESS: 'GET_TRANSACTION_REPORT_SUCCESS',
  GET_TRANSACTION_REPORT_PAGE_SUCCESS: 'GET_TRANSACTION_REPORT_PAGE_SUCCESS',
  GET_TRANSACTION_REPORT_FAILED: 'GET_TRANSACTION_REPORT_FAILED',
};

const InstallmentsConfigActions = {
  SET_ALLOWED_PLANS: 'SET_ALLOWED_PLANS',
  SET_DEFAULT_MIN_AMMOUNT: 'SET_DEFAULT_MIN_AMMOUNT',
  SET_CONFIG_FROM_LOCALSTORAGE: 'SET_CONFIG_FROM_LOCALSTORAGE',
};

export const StoreActions = {
  ...PracticeActions,
  ...AuthActions,
  ...StaffActions,
  ...TransactionActions,
  ...ReportingActions,
  ...InstallmentsConfigActions,
};
